import { Component, ElementRef, OnInit, ViewChild, SecurityContext } from '@angular/core';
import { PlantillaPdfDto } from '../../../dto/plantilla-pdf/plantilla-pdf.dto';
import { PlantillasPdfService } from '../../../services/plantillas-pdf.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { Jodit } from 'jodit';
import { InfoPantallaDTO } from '../../../dto/util/infoPantallaDTO';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { lastValueFrom } from 'rxjs';
import { UtilService } from '../../../services/util.service';
import { NotificationService } from '../../../services/notification.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-edicion-documento-adjunto',
  templateUrl: './edicion-documento-adjunto.component.html',
  styleUrl: './edicion-documento-adjunto.component.scss',
})
export class EdicionDocumentoAdjuntoComponent implements OnInit {
  @ViewChild('fileInputLogo1') fileInputLogo1!: ElementRef;
  @ViewChild('fileInputLogo2') fileInputLogo2!: ElementRef;
  @ViewChild('editorContainer', { static: false }) editorContainer!: ElementRef;
  private editor!: any;

  imageSrcLogo1: string | null = null;
  imageSrcLogo2: string | null = null;

  listaPlantillas?: PlantillaPdfDto[] = [];
  plantillaId?: number;
  plantilla?: PlantillaPdfDto | null;

  plantillaHtml?: string = '';
  form!: FormGroup;

  fileLogo1: File | null = null;
  fileLogo2: File | null = null;
  editableCuerpoPlantilla = '';
  infoPantalla!: InfoPantallaDTO;

  alertaText: any = {};

  editorConfig: any = {
    height: 350,
    events: {
      afterInit: (editor: any) => {
        let lastTableHTML = '';

        editor.events.on('change', () => {
          const table = editor.container.querySelector('table');
          if (table) {
            lastTableHTML = table.outerHTML;
          }
        });

        editor.events.on('keydown', (event: KeyboardEvent) => {
          const selection = editor.selection.current() as HTMLElement | null;

          if (event.key === 'Backspace' || event.key === 'Delete') {
            const parentTable = selection?.closest('table');

            if (parentTable) {
              const hasContent = parentTable.innerText.trim().length > 0;

              if (hasContent && !selection?.closest('td, th')) {
                event.preventDefault();
                event.stopPropagation();
                return false;
              }
            }
          }

          return true;
        });

        editor.events.on('afterCommand', () => {
          setTimeout(() => {
            const currentTable = editor.container.querySelector('table');

            if (!currentTable && lastTableHTML) {
              const tempDiv = document.createElement('div');
              tempDiv.innerHTML = lastTableHTML;
              const savedTable = tempDiv.querySelector('table');

              if (savedTable && savedTable.innerText.trim().length > 0) {
                editor.selection.insertHTML(lastTableHTML);
              }
            }
          }, 100);
        });
      },
    },
  };
  constructor(
    private fb: FormBuilder,
    private readonly location: Location,
    private readonly translate: TranslateService,
    private readonly alertaModalService: AlertaModalService,
    private readonly plantillasService: PlantillasPdfService,
    private readonly utilService: UtilService,
    private readonly notificationService: NotificationService,
    private readonly sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.translate.stream('alertas').forEach(text => {
      for (const key of Object.keys(text)) {
        this.alertaText[key] = text[key];
      }
    });

    this.buildForm();
    this.obtenerPlantillas();

    this.infoPantalla = {
      change: async op =>
        await this.guardarAntesDeSalir(
          this.alertaModalService,
          this.location,
          op
        ),
    };

    this.utilService.changeInfoPantalla(this.infoPantalla);

  }

  obtenerPlantillas() {
    this.plantillasService.obtenerPlantillas().subscribe(
      response => {
        this.listaPlantillas = response;
        if (this.listaPlantillas.length > 0) {
          this.plantillaId = this.listaPlantillas[0].Id_Plantilla_PDF;
          this.selectPlantilla();
        }
      },
      error => {
        this.notificationService.addNotification('error', 'No se pudieron cargar las plantillas');
        return;
      }
    );
  }

  ngAfterViewInit(): void {
    if (!this.editorContainer) {
      // this.notificationService.addNotification('error','No se encontró el contenedor del editor');
      return;
    }

    this.editor = new Jodit(
      this.editorContainer.nativeElement,
      this.editorConfig
    );
    this.editor.value = this.editableCuerpoPlantilla;

    this.editor.events.on('change', () => {
      this.editableCuerpoPlantilla = this.editor.value;
    });
  }

  async guardarAntesDeSalir(
    alertas: AlertaModalService,
    loc: Location,
    op?: () => void
  ) {
    await alertas.confirmacion(
      this.alertaText['recordatorio-campos-documento'],
      this.alertaText['almacenar-edicion-documento'],
      async () => {
        try {
          const response = await this.guardarPlantilla();
          if (response.success) {
            if (op) {
              op();
            } else {
              loc.back();
            }
          } else {
            await alertas.confirmacion(
              this.alertaText['salir-o-continuar-diligenciando'],
              this.alertaText['datos-no-guardados'],
              () => {
                if (op) {
                  op();
                } else {
                  loc.back();
                }
              },
              () => {
                // El usuario decide continuar diligenciando
              }
            );
          }
        } catch (error) {
          // Manejo de errores de llamada al servicio
          await alertas.confirmacion(
            this.alertaText['salir-o-continuar-diligenciando'],
            this.alertaText['datos-no-guardados'],
            () => {
              if (op) {
                op();
              } else {
                loc.back();
              }
            },
            () => {
              // El usuario decide continuar diligenciando
            }
          );
        }
      },
      () => {
        if (op) {
          op();
        } else {
          loc.back();
        }
      }
    );
  }

  buildForm() {
    this.form = this.fb.group({
      encabezadoPlantilla: ['', [Validators.required]],
      variables: ['', [Validators.required]],
    });
  }

  selectPlantilla(): void {
    const plantilla = this.listaPlantillas?.find(
      template => template.Id_Plantilla_PDF == this.plantillaId
    );
    this.onChangePlantilla(plantilla);
  }

  async onChangePlantilla(plantilla?: PlantillaPdfDto) {
    this.plantilla = plantilla;
    this.plantillaHtml = `<h5>${plantilla?.Encabezado_Plantilla}</h5>${plantilla?.Cuerpo_Plantilla}`;

    if (plantilla?.Url_Logo1?.includes('https://')) {
      this.fileLogo1 = await this.base64ToFile(
        plantilla?.Logo1 ?? '',
        plantilla?.Id_Plantilla_PDF +
        '_Logo.' +
        plantilla?.Url_Logo1.split('.').pop()
      );
      // Convertimos la imagen a Base64
      const reader = new FileReader();
      reader.onload = () => {
        this.imageSrcLogo1 = reader.result as string;
      };
      reader.readAsDataURL(this.fileLogo1);
    }

    if (plantilla?.Url_Logo2?.includes('https://')) {
      this.fileLogo2 = await this.base64ToFile(
        plantilla?.Logo2 ?? '',
        plantilla?.Id_Plantilla_PDF +
        '_Logo.' +
        plantilla?.Url_Logo2.split('.').pop()
      );
      const reader = new FileReader();
      reader.onload = () => {
        this.imageSrcLogo2 = reader.result as string;
      };
      reader.readAsDataURL(this.fileLogo2);
    }

    this.form
      .get('encabezadoPlantilla')
      ?.setValue(plantilla?.Encabezado_Plantilla);
    this.form.get('variables')?.setValue(plantilla?.Variables);
    this.updateEditableCuerpo();
  }

  openFilePickerLogo1() {
    this.fileInputLogo1.nativeElement.click();
  }

  openFilePickerLogo2() {
    this.fileInputLogo2.nativeElement.click();
  }

  onFileSelectedLogo1(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.fileLogo1 = new File(
        [file],
        'Logo1_' + file.name + '.' + file.name.split('.').pop(),
        {
          type: file.type,
          lastModified: file.lastModified,
        }
      );
      // Verificamos que sea una imagen
      if (!this.fileLogo1.type.startsWith('image/')) {
        this.fileLogo1 = null;
        this.imageSrcLogo1 = null;
        this.alertaModalService.error(
          'Imagen no válida',
          'Por favor, selecciona una imagen válida'
        );
      } else {
        // Convertimos la imagen a Base64
        const reader = new FileReader();
        reader.onload = () => {
          this.imageSrcLogo1 = reader.result as string; // Guardamos la imagen en Base64
        };
        reader.readAsDataURL(this.fileLogo1);
      }
    }
  }

  onFileSelectedLogo2(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.fileLogo2 = new File(
        [file],
        'Logo2_' + file.name + '.' + file.name.split('.').pop(),
        {
          type: file.type,
          lastModified: file.lastModified,
        }
      );
      // Verificamos que sea una imagen
      if (!this.fileLogo2.type.startsWith('image/')) {
        this.fileLogo2 = null;
        this.imageSrcLogo2 = null;
        this.alertaModalService.error(
          'Imagen no válida',
          'Por favor, selecciona una imagen válida'
        );
      } else {
        // Convertimos la imagen a Base64
        const reader = new FileReader();
        reader.onload = () => {
          this.imageSrcLogo2 = reader.result as string; // Guardamos la imagen en Base64
        };
        reader.readAsDataURL(this.fileLogo2);
      }
    }
  }

  updateEditableCuerpo(): void {
    this.editableCuerpoPlantilla = this.plantilla?.Cuerpo_Plantilla || '';

    setTimeout(() => {
      const editor = document.querySelector('.jodit-wysiwyg');
      if (editor) {
        editor.innerHTML = this.sanitizer.sanitize(SecurityContext.HTML, this.editableCuerpoPlantilla) || '';
      }
    }, 200);
  }

  async guardarPlantilla(): Promise<{ success: boolean; message?: string }> {
    if (!this.plantilla) {
      return { success: false, message: 'No hay plantilla para guardar.' };
    }

    const plantilla: PlantillaPdfDto = {
      Id_Plantilla_PDF: this.plantilla.Id_Plantilla_PDF,
      Nombre_Plantilla: this.plantilla.Nombre_Plantilla,
      Encabezado_Plantilla: this.form.get('encabezadoPlantilla')?.value,
      //Cuerpo_Plantilla: this.editableCuerpoPlantilla,
      Cuerpo_Plantilla: this.plantilla.Cuerpo_Plantilla,
      Variables: this.form.get('variables')?.value,
      Titulo_Plantilla: this.plantilla.Titulo_Plantilla,
      Url_Logo1: undefined,
      Url_Logo2: undefined,
    };

    const formData = await this.crearFormData(plantilla);

    try {
      const respuesta = await lastValueFrom(
        this.plantillasService.modificarPlantilla(formData)
      );

      const plantillaActualizada = respuesta.data;

      const index = this.listaPlantillas?.findIndex(
        p => p.Id_Plantilla_PDF === plantillaActualizada.Id_Plantilla_PDF
      );

      if (index !== undefined && index !== -1 && this.listaPlantillas) {
        this.listaPlantillas[index] = {
          ...this.listaPlantillas[index],
          ...plantillaActualizada,
        };
      }

      this.onChangePlantilla(plantillaActualizada!);

      this.alertaModalService.exito(
        'Plantilla modificada correctamente.',
        'La Plantilla ha sido modificada correctamente'
      );

      return { success: true };
    } catch (err: any) {
      this.alertaModalService.error(
        'Problema modificando la entidad.',
        err?.error?.message || 'Error desconocido'
      );

      return { success: false, message: err?.error?.message };
    }
  }

  private async crearFormData(plantilla: PlantillaPdfDto) {
    const formData = new FormData();
    formData.append('plantilla', JSON.stringify(plantilla));
    formData.append('archivos', this.fileLogo1 as File);
    formData.append('archivos', this.fileLogo2 as File);
    return formData;
  }

  async base64ToFile(base64String: string, fileName: string): Promise<File> {
    const matches = base64String.match(/^data:(.*);base64,(.*)$/);
    if (!matches || matches.length !== 3) {
      throw new Error('Base64 no válido');
    }

    const mimeType = matches[1];
    const base64Data = matches[2];

    const byteCharacters = atob(base64Data);

    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });
    return new File([blob], fileName, { type: mimeType });
  }
}
